import moment from 'moment';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import useStore from '../../../store/zustand/store';
import Button from '../../molecules/Button';
import GoActivityButton from './components/GoActivityButton';
import LoginButton from './components/LoginButton';
import SubscribeButton from './components/SubscribeButton';
import UnsubscribeButton from './components/UnsusbcribeButton';
import config from '../../../config';
import { isHermandar } from 'utils/contants';
import UnlockButton from './components/UnlockButton/UnlockButton';

const DISABLED_STATUS = [
  3, // Cerrada
  4, // Archivada
];

const now = moment().subtract(1, 'days');

const ActivityButton = ({ activity, btnCard = false }) => {
  const user = useStore((state) => state.user);
  const [isSuscribed, setIsSuscribed] = useState(!!activity.activity_user_id);
  const { t } = useTranslation();
  const location = useLocation();

  const isOnActivityDetailPage = location.pathname === `/detail/${activity.id}`;
  const isPremium = activity?.is_premium;
  const user_premium = user && ['user-read-only'].includes(user?.role_name);

  const isEnable = useMemo(() => {
    // Si la actividad tiene este estado, no se puede inscribir
    if (DISABLED_STATUS.includes(activity.status)) return false;

    // Si todavia no paso la fecha de cierre o es una actividad continua, se puede inscribir
    if (now <= moment(activity.deadline) || activity.continuous_activity) return true;

    // no se puede inscribir
    return false;
  }, [activity]);

  // Si no hay usuario, mostrar boton de Login
  if (!user) return <LoginButton btnCard={!config.profile_globant && btnCard} />;

  // Si la actividad es premium y el usuario no es premium, mostrar botón de desbloqueo
  if (isPremium && !user_premium) {
    return <UnlockButton activity={activity} />;
  }

  // Si el administrador oculta los botones de postulacion/despostulacion
  if (activity.hidden_button) {
    // Solo mostrar el botón de ir a la actividad si el usuario esta suscrito
    if (isSuscribed) {
      return <GoActivityButton activity={activity} btnCard={!config.profile_globant && btnCard} />;
    }
    return null; // No mostrar otros botones
  }

  //if (!user) return <LoginButton />;
  if (!isEnable) {
    return (
      <Button
        className={'button-reactour'}
        style={btnCard ? { borderRadius: '10px', width: '100%', padding: '5px 0px', fontWeight: 500 } : {}}
      >
        {t(!!activity.guide_id || isHermandar ? 'button.enroll_me' : 'button.apply')}
      </Button>
    );
  }

  if (!isSuscribed) {
    return (
      <SubscribeButton
        userPremium={user_premium}
        activity={activity}
        setIsSuscribed={setIsSuscribed}
        btnCard={!config.profile_globant && btnCard}
      />
    );
  }

  if (isOnActivityDetailPage) {
    return <UnsubscribeButton activity={activity} setIsSuscribed={setIsSuscribed} />;
  } else if (!isOnActivityDetailPage) {
    return <GoActivityButton activity={activity} btnCard={!config.profile_globant && btnCard} />;
  }

  return (
    <Button
      className="button-reactour"
      style={btnCard ? { borderRadius: '10px', width: '100%', padding: '5px 0px', fontWeight: 500 } : {}}
    >
      {t(!!activity.guide_id || isHermandar ? 'button.enroll_me' : 'button.apply')}
    </Button>
  );
};

export default ActivityButton;
